import {useUserState} from "store/user-store";

export const BROWSER_TIMEZONE = "_BROWSER_"

export const useDisplayTimezone = () => {
  return useUserState(state => state.getDisplayZoneId());
};

export const useCompanyTimezone = () => {
  return useUserState(state => state.getCompanyZoneId());
}

export const useTimezone = () => {
  const displayTz = useDisplayTimezone();
  const companyTz = useCompanyTimezone();

  return { display: displayTz, company: companyTz };
}